import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { FormsModule } from '@angular/forms';
import { HelpersModule } from '@core/components/helpers/helpers.module';
import { LabelsModule } from '@core/components/labels/labels.module';
import { FilesListModule } from '@core/components/files/lists/lists.module';
import { CoreCustomFormsFieldHelpersModule } from '@core/custom-forms/components/helpers/custom-forms-field-helpers.module';

import { ProjectsDetailsHelpersModule } from '../../../helpers/helpers.module';
import { ProjectsDetailsInfoFeaturesModule } from '../../../info/features/features.module';

import { ProjectDetailsLogbookEventRequestPropertiesComponent } from './request-properties/request-properties.component';
import { ProjectDetailsLogbookEventVersionPropertiesComponent } from './version-properties/version-properties.component';
import { ProjectDetailsLogbookEventPropertiesMainComponent } from './main/main.component';
import { ProjectDetailsLogbookEventUserOnPropertiesComponent } from './user-on-properties/user-on-properties.component';
import { ProjectDetailsLogbookEventSharePropertiesComponent } from './share-properties/share-properties.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        CoreModule,
        HelpersModule,
        LabelsModule,
        FilesListModule,
        ProjectsDetailsHelpersModule,
        ProjectsDetailsInfoFeaturesModule,
        CoreCustomFormsFieldHelpersModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        ProjectDetailsLogbookEventPropertiesMainComponent,
        ProjectDetailsLogbookEventRequestPropertiesComponent,
        ProjectDetailsLogbookEventVersionPropertiesComponent,
        ProjectDetailsLogbookEventSharePropertiesComponent,
        ProjectDetailsLogbookEventUserOnPropertiesComponent
        
    ],
    exports: [
        ProjectDetailsLogbookEventPropertiesMainComponent
    ],

})
export class ProjectDetailsLogbookEventPropertiesModule { }